var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/*
 * @Author: yejianfei
 * @Date: 2023-04-03 22:34:45
 * @LastEditors: yejianfei
 * @LastEditTime: 2023-04-11 14:15:19
 * @Description:
 * @Developer:
 */
import React from 'react';
import AdminPage from '../../components/antd/AdminPage';
import { Button, Card, Col, Form, Input, Row, Space, Radio, Modal, QRCode } from 'antd';
import APITable from '../../components/antd/APITable';
import WithRouter from '../../components/WithRouter';
import APISelect from '../../components/antd/APISelect';
import IconFont from '../../icons';
import { CancelRuleOptions, BooleanOptions, BooleanFilter } from '../../options';
let AdminDiagnosticListPage = class AdminDiagnosticListPage extends React.Component {
    constructor() {
        super(...arguments);
        this.base = CONFIG.http.qrcode;
        this.state = {
            showQrCode: false,
            path: ''
        };
    }
    onOpenQrCode(path) {
        this.setState({ showQrCode: true, path });
    }
    download() {
        var _a;
        const canvas = (_a = document.getElementById('qrcode')) === null || _a === void 0 ? void 0 : _a.querySelector('canvas');
        if (canvas) {
            const url = canvas.toDataURL();
            const a = document.createElement('a');
            a.download = 'QRCode.png';
            a.href = url;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            this.setState({ showQrCode: false });
        }
    }
    render() {
        return (React.createElement(AdminPage, null,
            React.createElement(Card, { style: { height: '100%' }, bodyStyle: { padding: 12, height: '100%' } },
                React.createElement(APITable, { bordered: true, tableLayout: 'fixed', loader: `/admin/organizations/list/:page?type=department`, initialParams: {
                        page: 1,
                        size: 25,
                        filters: true
                    }, size: 'small', rowKey: 'id', 
                    // scroll={{y: 100}}
                    pagination: { showSizeChanger: false }, columns: [{
                            title: '科室名称',
                            width: 200,
                            align: 'center',
                            dataIndex: 'name'
                        }, {
                            title: '科室编码',
                            width: 200,
                            align: 'center',
                            dataIndex: 'code'
                        }, {
                            title: '所属医院',
                            width: 200,
                            align: 'center',
                            dataIndex: ['parent', 'name']
                        }, {
                            title: '预约确认',
                            width: 200,
                            align: 'center',
                            dataIndex: ['extra', 'appointment_confirm'],
                            render: (value) => BooleanFilter[value]
                        }, {
                            title: '医生选择',
                            width: 200,
                            align: 'center',
                            dataIndex: ['extra', 'doctor_option'],
                            render: (value) => BooleanFilter[value]
                        }, {
                            title: '操作',
                            dataIndex: 'operation',
                            align: 'center',
                            width: 170,
                            render: ((text, record, index, instance) => {
                                return (React.createElement(Space, null,
                                    React.createElement(Button, { type: "link", onClick: () => instance.modal(record.id) }, "\u7F16\u8F91"),
                                    React.createElement(Button, { danger: true, type: "link", onClick: () => instance.delete(record.id) }, "\u5220\u9664"),
                                    React.createElement(Button, { type: "link", onClick: () => this.onOpenQrCode(record.full_path) }, "\u4E8C\u7EF4\u7801")));
                            })
                        }], search: {
                        children: (table) => {
                            return (React.createElement(Row, null,
                                React.createElement(Col, { span: 8 },
                                    React.createElement(Form.Item, { name: ['keywords'] },
                                        React.createElement(Input.Search, { placeholder: '\u8F93\u5165\u533B\u9662\u540D\u79F0\u68C0\u7D22', allowClear: true, enterButton: true, onSearch: () => table.search() }))),
                                React.createElement(Col, { flex: 1 },
                                    React.createElement(Row, { justify: 'end' },
                                        React.createElement(Space, null,
                                            React.createElement(Form.Item, null,
                                                React.createElement(Button, { onClick: () => table.modal(), icon: React.createElement(IconFont, { type: 'icon-diagnosis-add' }) })))))));
                        }
                    }, form: {
                        title: '科室信息',
                        action: '/admin/organizations',
                        loader: '/admin/organizations/:id',
                        name: 'department-form',
                        initialValues: {
                            type: 'department',
                            extra: {
                                'appointment_confirm': '',
                                'doctor_option': '',
                                'cancel_rule': '',
                                'cancel_rule_hour': ''
                            }
                        },
                        onLoaded: (values) => __awaiter(this, void 0, void 0, function* () { return (Object.assign(Object.assign({}, values), { password: Date.now() })); }),
                        children: (values) => {
                            var _a, _b, _c;
                            return (React.createElement(React.Fragment, null,
                                React.createElement(Form.Item, { label: '\u79D1\u5BA4\u540D\u79F0', labelCol: { span: 5 }, name: ['name'], rules: [{ required: true, message: '请输入科室名称' }] },
                                    React.createElement(Input, { placeholder: '\u8BF7\u8F93\u5165\u79D1\u5BA4\u540D\u79F0' })),
                                React.createElement(Form.Item, { label: '\u79D1\u5BA4\u7F16\u7801', labelCol: { span: 5 }, name: ['code'], rules: [{ required: true, message: '请输入科室编码' }] },
                                    React.createElement(Input, { placeholder: '\u8BF7\u8F93\u5165\u79D1\u5BA4\u7F16\u7801' })),
                                React.createElement(Form.Item, { label: '\u6240\u5C5E\u533B\u9662', labelCol: { span: 5 }, name: ['path'], rules: [{ required: true, message: '请选择医院' }] },
                                    React.createElement(APISelect, { loader: '/admin/organizations/tree/:path/children?type=hospital', placeholder: "\u8BF7\u9009\u62E9\u533B\u9662", params: {
                                            path: 'root'
                                        }, fieldNames: {
                                            label: 'name',
                                            value: 'id'
                                        } })),
                                React.createElement(Form.Item, { label: '\u9884\u7EA6\u786E\u8BA4', labelCol: { span: 5 }, name: ['extra', 'appointment_confirm'], rules: [{ required: true, message: '请选择' }] },
                                    React.createElement(Radio.Group, { options: BooleanOptions.map(item => ({ label: item.name, value: item.id })) })),
                                React.createElement(Form.Item, { label: '\u533B\u751F\u9009\u62E9', labelCol: { span: 5 }, name: ['extra', 'doctor_option'], rules: [{ required: true, message: '请选择' }] },
                                    React.createElement(Radio.Group, { options: BooleanOptions.map(item => ({ label: item.name, value: item.id })) })),
                                React.createElement(Form.Item, { label: '\u533B\u751F\u6392\u73ED', labelCol: { span: 5 }, name: ['extra', 'doctor_schedule'], rules: [{ required: true, message: '请选择' }] },
                                    React.createElement(Radio.Group, { options: BooleanOptions.map(item => ({ label: item.name, value: item.id })) })),
                                React.createElement(Form.Item, { label: '\u53D6\u6D88\u9650\u5236', labelCol: { span: 5 }, name: ['extra', 'cancel_rule'], rules: [{ required: true, message: '请选择' }] },
                                    React.createElement(Radio.Group, { options: CancelRuleOptions.map(item => ({ label: item.name, value: item.id })) })),
                                ((_a = values === null || values === void 0 ? void 0 : values.extra) === null || _a === void 0 ? void 0 : _a.cancel_rule) === 1 ? (React.createElement(Form.Item, { hidden: ((_b = values === null || values === void 0 ? void 0 : values.extra) === null || _b === void 0 ? void 0 : _b.cancel_rule) !== 1, label: '\u5C0F\u65F6', labelCol: { span: 5 }, name: ['extra', 'cancel_rule_hour'], rules: [{ required: true, message: '请输入小时' }] },
                                    React.createElement(Input, { type: 'number', placeholder: '\u8BF7\u8F93\u5165\u5C0F\u65F6', addonAfter: '\u5C0F\u65F6\u540E' }))) : null,
                                ((_c = values === null || values === void 0 ? void 0 : values.extra) === null || _c === void 0 ? void 0 : _c.cancel_rule) === 2 ? (React.createElement(Form.Item, { label: '\u5C0F\u65F6', labelCol: { span: 5 }, name: ['extra', 'cancel_rule_hour'], rules: [{ required: true, message: '请输入小时' }] },
                                    React.createElement(Input, { type: 'number', placeholder: '\u8BF7\u8F93\u5165\u5C0F\u65F6', addonAfter: '\u5C0F\u65F6\u524D' }))) : null));
                        }
                    } })),
            React.createElement(Modal, { title: "\u79D1\u5BA4\u4E8C\u7EF4\u7801", open: this.state.showQrCode, onOk: () => this.download(), onCancel: () => this.setState({ showQrCode: false }), okText: '\u4E0B\u8F7D', cancelText: '\u5173\u95ED' },
                React.createElement(Row, null,
                    React.createElement(Col, { span: 8 }),
                    React.createElement(Col, { id: 'qrcode' },
                        React.createElement(QRCode, { value: `${this.base}?qrcode=${this.state.path}` }))))));
    }
};
AdminDiagnosticListPage = __decorate([
    WithRouter()
], AdminDiagnosticListPage);
export default AdminDiagnosticListPage;
